import { createSlice } from "@reduxjs/toolkit"

const initialState = {
  showIFrame: false
}

export const sliceKey = "iframe"

export const iframeSlice = createSlice({
  name: sliceKey,
  initialState,
  reducers: {
    setShowIframe: (state, { payload }) => {
      try {
        state.showIFrame = payload
      } catch (e) {
        console.log(e)
      }
    }
  }
})

export const { setShowIframe } = iframeSlice.actions

export default iframeSlice.reducer
